import React from "react";
import { useParams } from "react-router-dom";
import { useGetQuizByIdQuery } from "../../../features/quizzes/quizzesApi";
import EditForm from "./EditForm";

const EditQuiz = () => {
  const { id } = useParams();

  const { data, isLoading, isError } = useGetQuizByIdQuery(id);

  //   decide what to render
  let content = null;

  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong...</div>;
  }
  if (!isLoading && !isError && data) {
    content = <EditForm quiz={data} />;
  }

  return <div className="mx-auto max-w-5xl px-5 lg:px-20">{content}</div>;
};

export default EditQuiz;
